var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-bar shadow d-flex w-100",staticStyle:{"height":"1rem"}},_vm._l((_vm.steps),function(step){return _c('div',{staticClass:"w-100 step-wrapper"},[_c('div',{staticClass:"w-100 h-100 step",class:{ filled:step }})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }